// קובץ זה מגדיר את כל הנתיבים באפליקציה
export const ROUTES = {
  PROJECT_DOCUMENT_VIEW: "/project-document/:documentId/:docSourceType?",
  WEEKLY_CALENDAR: "/weekly-calendar",
  WEEKLY_CALENDAR_PROJECT: "/weekly-calendar/:projectId",
  WEEKLY_CALENDAR_PROJECT_CONTACT:
    "/weekly-calendar/:projectId/contact/:contactId",

  // נתיבים ציבוריים - כל אחד יכול לגשת
  HOME: "/",
  LOGIN: "/login",
  // נתיבים מוגנים - רק משתמשים מחוברים
  DASHBOARD: "/dashboard",
  CALENDAR: "/calendar",
  LEADS: "/leads",
  FILE_STORAGE: "/file-storage",
  MSG_TEMPLATES: "/msg-templates",
  DOCUMENTS: "/documents",
  REPORTS: "/reports",
  REPORT_DATA: "/reportData/:reportId",
  OPEN_FORMAT_REPORT: "/open-format-report",
  EXPENSES: "/expenses",
  TEAM: "/team",
  SETTINGS: "/settings",
  USERS: "/users",
  PROFILE: "/profile",
  TASKS: "/tasks",
  CONTACTS: "/contacts",
  COMMUNICATION: "/communication/contact/:contactId/:projectId?",
  COMMUNICATION_HOME: "/communication",
  // נתיבי פרויקטים - חדש
  PROJECTS: "/projects",
  PROJECT_DETAILS: "/projects/:projectId",
  PROJECT_EDIT: "/projects/:projectId/edit",

  // נתיבי מסמכי הנהלת חשבונות
  BOOKKEEPING_DOCUMENTS: "/bookkeeping-documents/:type/:projectId?",
  PREVIEW_PDF: "/preview-pdf/:projectId",
  // נתיבי הגדרות
  SETTINGS_RESOURCES: "/settings/resources",
  SETTINGS_TABLES: "/settings/tables",
  SETTINGS_ATTACHMENTS: "/settings/attachments",
  SETTINGS_MENUS: "/settings/menus",
  SETTINGS_MENUS_CATEGORIES: "/settings/menus/:menuId/categories",
  SETTINGS_DOCUMENTS: "/settings/documents",
  SETTINGS_ITEMS: "/settings/items",
  SETTINGS_INTERFACES: "/settings/interfaces",
  SETTINGS_CUSTOM_FIELD: "/settings/customField",
  SETTINGS_BASEITEMS: "/settings/baseitems",
  SETTINGS_PROJECT_TYPES: "/settings/project-types", // הוספה חדשה
  SETTINGS_BUSINESS_DETAILS: "/settings/business-details",
  SETTINGS_ADMIN: "/settings/admin",
  SETTINGS_USERS_AND_PERMISSIONS: "/settings/users-and-permissions",
  PROJECT_EVENT: "/projects/event/:projectId",
  SETTINGS_LEGAL_APPENDICES: "/settings/legal-appendices",
  //יצירת תפריט
  PROJECT_MENU: "/project-menu/:projectId?",
  //לינק
  INVITATION_LINK: "/invitation/:invitaionKey",
  SIGN_DOCUMENT_LINK: "/sign-document/:signRequestKey",
  MENU_SELECT: "selected-menu/:uniqueKey",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:resetTokenKey",

  // נתיב חדש להפקת מסמך
  DOCUMENT_GENERATION: "/document-generation/:projectId/:documentTypeId?",

  // נתיבי אדמין - רק אדמינים
  ADMIN: "/admin",
  ADMIN_USERS: "/admin/users",

  //איש קשר
  CONTACT_CARD: "/contact-card/:contactId",
  // נתיבי שגיאה
  NOT_FOUND: "/404",
  UNAUTHORIZED: "/unauthorized",

  // חשבונית ישראל OAuth callback
  ISRAEL_INVOICE_AUTH_RESPONSE: "/israelinvoice/authresponse",
  SETTINGS_BK_EXPORT: "/settings/bk-export",
  SETTINGS_AUTOMATIONS: "/settings/automations",
  SETTINGS_AUTOMATION_SETTINGS: "/settings/automations/settings/:automationId?",
} as const;

// טיפוס לנתיבים - מבטיח type safety
export type RouteKeys = keyof typeof ROUTES;
export type RouteValues = (typeof ROUTES)[RouteKeys];

// פונקציות עזר ליצירת נתיבים עם פרמטרים
export const getMenuCategoriesRoute = (menuId: number) =>
  `/settings/menus/${menuId}/categories`;

export const getProjectDetailsRoute = (projectId: number) =>
  `/projects/${projectId}`;

export const getProjectEditRoute = (projectId: number) =>
  `/projects/${projectId}/edit`;
export const getProjectEventRoute = (projectId: number) =>
  `/projects/event/${projectId}`;
export const getDocumentGenerationRoute = (projectId: number) =>
  `/document-generation/${projectId}`;

export const getAutomationSettingsRoute = (automationId?: number) =>
  automationId
    ? `/settings/automations/settings/${automationId}`
    : "/settings/automations/settings";
